import React, { useContext } from 'react';
import { WarehouseQuoteDetailDataForm, WarehouseQuoteDetailFilters } from '../../../../app/models/WareHouseQuoteDetail';
import { AuthContext } from '../../../../contexts/AuthContext';
import { formatMoney, formatNumber } from '../../../../utils/utils';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { WarehouseOrderItemDataForm, WarehouseOrderItemFilters } from '../../../../app/models/WarehouseOrderItem';
import WarehouseOrderItemChangeStatus from '../WarehouseOrderItemChangeStatus';
import { WarehouseOrderItemStatus } from '../../../../app/models/WarehouseOrderItemStatus';

interface Props {
    warehouseOrderItems: WarehouseOrderItemDataForm[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    destroy?: (id: number) => void;
    show?: (id: number) => void;
    filter: WarehouseOrderItemFilters;
    setFilter: (filter: WarehouseOrderItemFilters) => void;
    isShow?: boolean;
    paginationRowsPerPageOptions?: any[];
    statuses: WarehouseOrderItemStatus[];
    callbackSuccess?: () => void;
    canBeEdited?: boolean;
    changeStatus: boolean;
    reloadModule?: () => void;


    
}

const WarehouseOrderItemsDataTable = ({
    warehouseOrderItems,
    totalRows,
    isShow = false,
    loading = false,
    edit,
    destroy,
    show,
    statuses,
    filter,
    setFilter,
    callbackSuccess,
    canBeEdited,
}: Props) => {
    const { auth } = useContext(AuthContext);

    const columns = [

        {
            name: 'ID',
            selector: (row: any) => row.position,
            sortable: true,
            sortField: 'position',
            cell: (row: any) => <span>{row.position}</span>
        },
        {
            name: 'Servicio',
            selector: (row: any) => row.service,
            sortable: true,
            sortField: 'service',
            cell: (row: any) => <span>{row.service}</span>
        },
        {
            name: 'Fecha Cuota',
            selector: (row: any) => row.quota_date,
            sortable: true,
            sortField: 'quota_date',
            cell: (row: any) => <span>{row.quota_date}</span>
        },
        {
            name: 'Producto',
            selector: (row: any) => row.product,
            sortable: true,
            sortField: 'product',
            cell: (row: any) => <span>{row.product}</span>
        },
        {
            name: 'Cantidad',
            selector: (row: any) => row.quantity,
            sortable: true,
            sortField: 'quantity',
            cell: (row: any) => formatNumber(row.quantity)
        },
        {
            name: 'Unidad Cantidad',
            selector: (row: any) => row.quantity_unit,
            sortable: true,
            sortField: 'quantity_unit',
            cell: (row: any) => <span>{row.quantity_unit}</span>
        },
        {
            name: 'Almacén',
            selector: (row: any) => row.warehouse,
            sortable: true,
            sortField: 'depot',
            cell: (row: any) => <span>{row.depot}</span>
        },
        {
            name: 'Precio Unitario Venta',
            selector: (row: any) => row.unit_price,
            sortable: true,
            sortField: 'unit_price',
            cell: (row: any) =>
                formatMoney(row.unit_price, row.currency ?? 'CLP', true)
        },
        {
            name: 'Moneda Venta',
            selector: (row: any) => row.currency,
            sortable: true,
            sortField: 'currency',
            cell: (row: any) => <span>{row.currency}</span>
        },
        {
            name: 'Unidad de Venta',
            selector: (row: any) => row.sale_unit,
            sortable: true,
            sortField: 'sale_unit',
            cell: (row: any) => <span>{row.rate_unit}</span>
        },
        {
            name: 'Estado',
            selector: (row: any) => row?.status,
            sortable: true,
            sortField: 'status',
            width: '140px',
            cell: (row: any, index: any, column: any) => {
                const status = statuses.find((quoteStatus) => quoteStatus.id === row.status);
                if (statuses.length > 0) {
                    if (canBeEdited) {
                        return (
                            <WarehouseOrderItemChangeStatus
                                callbackSuccess={callbackSuccess}
                                statuses={row.status_choices}
                                selectedStatus={status!}
                                warehouseOrderItemId={row.id!}
                            />
                        );
                    } else {
                        return row.status_selected.name;
                    }
                }
            }
        },
        {
            name: 'Acciones',
            cell: (row: any) => {
                return (
                    <div className="d-flex gap-1">
                        {show && (
                            <ButtonTableAction
                                callbackFunction={() => show(row.id ?? -1)}
                                classIcon={'mdi mdi-eye'}
                                colorIcon={'text-info'}
                                title={'Ver'}
                            />
                        )}
                    {!isShow && edit && (
                        <ButtonTableAction
                        callbackFunction={() => edit(row.id ?? -1)}
                        classIcon="mdi mdi-pencil"
                        colorIcon="text-warning"
                        title="Editar"
                        />
                    )}
                    {!isShow && destroy && (
                        <ButtonTableAction
                        callbackFunction={() => destroy(row.id ?? -1)}
                        classIcon="mdi mdi-delete"
                        colorIcon="text-danger"
                        title="Eliminar"
                        />
                    )}
                    </div>
                );
            }
        }
    ];

    return (
        <div className="row">
            <div className="col-12 mt-4">
                <DefaultDataTable
                    columns={columns}
                    data={warehouseOrderItems}
                    progressPending={loading}
                    filter={filter}
                    setFilter={setFilter}
                    paginationTotalRows={totalRows}
                />
            </div>
        </div>
    );
};

export default WarehouseOrderItemsDataTable;
